import { toast } from 'react-toastify';
export const showErrorToast = (msg: any, toastConfig?: any) => { toast.error(msg, toastConfig); }
export const showSuccessToast = (msg: any, toastConfig?: any) => { toast.success(msg, toastConfig); }